import React from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

/**
 * Geo Distribution Bar Chart Component using MUI X Charts
 * Displays a horizontal bar chart showing geographic distribution
 * @param {Object} props
 * @param {Array} props.values - Array of geographic data with state, perc, and total properties
 * @returns {import("react").ReactElement}
 */
export default function GeoDistributionBar(props) {
  const { values = [] } = props;

  if (!values || values.length === 0) {
    return null;
  }

  // Ensure we always have 3 items (pad with empty if needed)
  const paddedValues = [...values];
  while (paddedValues.length < 3) {
    paddedValues.unshift({ state: "", perc: 0, total: 0 });
  }

  // Take only top 3
  const topValues = paddedValues.slice(0, 3);

  const categories = topValues.map((v) => v.state || "");
  const percentages = topValues.map((v) => v.perc || 0);
  const totals = topValues.map((v) => v.total || 0);

  return (
    <Box sx={{ width: 275, height: 110, display: "inline-block" }}>
      <BarChart
        yAxis={[
          {
            scaleType: "band",
            data: categories,
            disableLine: true,
            disableTicks: true,
            tickLabelStyle: {
              fontSize: 11,
              fontWeight: 500,
            },
          },
        ]}
        xAxis={[
          {
            disableLine: true,
            disableTicks: true,
            tickLabelStyle: { display: "none" },
          },
        ]}
        series={[
          {
            data: percentages,
            color: "#03a9f4",
            valueFormatter: (value, { dataIndex }) => {
              const total = totals[dataIndex];
              return `${total?.toLocaleString()} emails (${value?.toFixed(1)}%)`;
            },
          },
        ]}
        layout="horizontal"
        width={275}
        height={110}
        margin={{ top: 5, right: 50, bottom: 5, left: 40 }}
        hideLegend
        barLabel={(item) => `${item.value?.toFixed(0)}%`}
        sx={{
          "& .MuiBarLabel-root": {
            fontSize: 11,
            fill: "#333",
            fontWeight: 500,
          },
        }}
      />
    </Box>
  );
}
